import httpClient from './httpClient';
import objectToFormData from './objectToFormData';
import { stringify } from 'qs';

const apiUrl = process.env.REACT_APP_BACKEND_URL;


export { apiUrl };

function createFormData(data) {
  const { file, imgFile, documentFile, homeworkFile, ...rest } = data;
  const formData = objectToFormData(rest);
  if (file) {
    formData.append('file', file.rawFile);
  }
  if (imgFile) {
    formData.append('imgFile', imgFile.rawFile);
  }
  if (documentFile) {
    formData.append('documentFile', documentFile.rawFile);
  }
  if (homeworkFile) {
    formData.append('homeworkFile', homeworkFile.rawFile);
  }
  return formData;
}

const handleSkillsCourseStatusHistory = async (url, params) => {
  const { filter } = params;
  const courseId = filter?.courseId;

  if (!courseId) {
    return { data: [], total: 0 };
  }

  const customUrl = `${apiUrl}/skills/courses/${courseId}/statusHistory`;
  const { json } = await httpClient(customUrl);

  return {
    data: json,
    total: json.length,
  };
};

const handleUserDevices = async (resource, params) => {
  const { id } = params;
  const { field, order } = params.sort;
  const url = `${apiUrl}/users/${id}/devices?${stringify({ sort: [field, order] })}`;
  const { json } = await httpClient(url);
  return {
    data: json,
    total: Array.isArray(json) ? json.length : 0,
  };
};

export default {
  getList: (resource, params) => {
    if (resource === 'userDevices') {
      const id = params.filter.userId;
      return handleUserDevices(resource, { id, sort: params.sort });
    }
    if (resource === 'skills/courses/statusHistory') {
      return handleSkillsCourseStatusHistory(resource, params);
    }

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: [field, order],
      page: page - 1, perPage,
      filter: params.filter,
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => {
      console.log(`getList response for ${resource}:`, json);
      return {
        data: json,
        total: parseInt(
          headers
            .get('content-range')
            .split('/')
            .pop(),
          10,
        ),
      };
    });
  },
  importCSV: (resource, params) => {
    const url = `${apiUrl}/${resource}/csv`;
    return httpClient(url, {
      method: 'POST',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data:json }));
  },

  getOne: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => {
      console.log(`getOne response for ${resource}/${params.id}:`, json);
      return {
        data: json,
      };
    }),

  get: (resource) =>
    httpClient(`${apiUrl}/${resource}`).then(({ json }) => ({
      data: json,
    })),

  getMany: (resource, params) => {
    const query = {
      filter: { id: params.ids },
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({ data: json }));
  },

  getManyReference: (resource, params) => {
    if ((resource === 'payments' || resource === 'paymentLogs') && params.target === 'userId') {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query = stringify({
        sort: [field, order],
        page: page - 1,
        perPage,
        filter: params.filter,
      });

      const url = `${apiUrl}/users/${params.id}/${resource}?${query}`;
      return httpClient(url).then(({ headers, json }) => ({
        data: json,
        total: parseInt(
          (headers.get('content-range') || '0/0').split('/').pop(),
          10
        ),
      }));
    }

    const nestedMatch = resource.match(/^users\/:id\/(.+)$/);
    if (nestedMatch) {
      const childResource = nestedMatch[1];
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query = stringify({
        sort: [field, order],
        page: page - 1,
        perPage,
        ...params.filter
      });

      const url = `${apiUrl}/users/${params.id}/${childResource}?${query}`;
      return httpClient(url).then(({ headers, json }) => ({
        data: json,
        total: parseInt(
          (headers.get('content-range') || '0/0').split('/').pop(),
          10
        ),
      }));
    }

    // 2) бусад resource-ууд (хуучин код)
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: [field, order],
      page: page - 1, perPage,
      filter: {
        ...params.filter,
        [params.target]: params.id,
      },
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json,
      total: parseInt(
        headers
          .get('content-range')
          .split('/')
          .pop(),
        10,
      ),
    }));
  },

  update: (resource, params) => {
    if (params.data.file || params.data.imgFile || params.data.documentFile || params.data.homeworkFile) {
      const fd = createFormData(params.data);

      return httpClient(`${apiUrl}/${resource}/${params.id}`, {
        method: 'PUT',
        body: fd,
      }).then(({ json }) => ({
        data: { ...params.data, id: json.id },
      }));
    }

    return httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  updateMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  patch: (resource, params) => {
    return httpClient(`${apiUrl}/${resource}`, {
      method: 'PATCH',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  create: (resource, params) => {
    // If we have files we need to form-data

    if (params.data.file || params.data.imgFile || params.data.documentFile || params.data.homeworkFile) {
      const fd = createFormData(params.data);
      return httpClient(`${apiUrl}/${resource}`, {
        method: 'POST',
        body: fd,
      }).then(({ json }) => ({
        data: { ...params.data, id: json.id },
      }));
    }
    return httpClient(`${apiUrl}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    }));
  },

  delete: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => ({ data: json })),

  deleteMany: (resource, params) => {
    const query = { id: params.ids };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: 'DELETE',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
  post: (resource, params) => {
    const { data = {} } = params;
    return httpClient(`${apiUrl}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(({ json }) => json);
  },
};
